import * as angular from "angular";
import {IController, IIntervalService} from "angular";

export class BringozCountdownTimerCtrl implements IController {
  timeCycleSeconds: number;
  onTimeCycleDone: Function;

  public displayTime: string;
  private countDownIntervalRef: any;
  private currentCycle;


  /* @ngInject */
  constructor(private $interval: IIntervalService) {
  }


  $onChanges(changes) {
    if (changes.timeCycleSeconds) {
      this.cancelInterval();

      if (this.timeCycleSeconds) {
        this.setInterval();
      }
    }
  }

  $onDestroy() {
    this.cancelInterval();
  }


  private cancelInterval() {
    if (this.countDownIntervalRef) {
      this.$interval.cancel(this.countDownIntervalRef);
    }
  }

  private setInterval() {
    this.currentCycle = this.timeCycleSeconds;
    this.countDownIntervalRef = this.$interval(() => {

      if (!this.currentCycle) {
        this.onTimeCycleDone();
        this.cancelInterval();
      }

      this.displayTime = this.setTimeString(this.currentCycle);
      this.currentCycle--;

    }, 1000);

  }

  private setTimeString(number) {
    const seconds = number % 60;
    const minutes = ((number - seconds) / 60) % 60;
    const hours = Math.floor(number / (60 * 60));

    return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozCountdownTimer', {
    bindings: {
      timeCycleSeconds: '<?',
      onTimeCycleDone: '&'
    },
    template: require('./bringoz-countdown-timer.html').default,
    controller: BringozCountdownTimerCtrl
  });
